import { render, staticRenderFns } from "./checkResult.vue?vue&type=template&id=72adc22e&scoped=true&"
import script from "./checkResult.vue?vue&type=script&lang=js&"
export * from "./checkResult.vue?vue&type=script&lang=js&"
import style0 from "./checkResult.vue?vue&type=style&index=0&id=72adc22e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72adc22e",
  null
  
)

export default component.exports